import { APP_INITIALIZER, inject, Provider } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { IDENTITY_PROVIDER } from '../../config/identity-provider';
import { Auth0AuthProvider } from './auth0-auth.provider';
import { AUTH_PROVIDER } from './auth-provider';
import { KeycloakAuthProvider } from './keycloak-auth.provider';

export function provideAuthProvider(): Provider[] {
  return [
    KeycloakService,
    KeycloakAuthProvider,
    Auth0AuthProvider,
    {
      provide: AUTH_PROVIDER,
      useFactory: () =>
        IDENTITY_PROVIDER === 'keycloak' ? inject(KeycloakAuthProvider) : inject(Auth0AuthProvider),
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const provider = inject(AUTH_PROVIDER);
        return () => provider.init();
      },
      multi: true,
    },
  ];
}
